import { WorshipReport } from '../../types/worshipReport';
import { Eye, Calendar, Mic2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { useState, useEffect } from 'react';

interface RecentReportsProps {
  reports: WorshipReport[];
  onPreview: (report: WorshipReport) => void;
}

export function RecentReports({ reports, onPreview }: RecentReportsProps) {
  const [speakerNames, setSpeakerNames] = useState<{[key: string]: string}>({});

  useEffect(() => {
    const fetchSpeakerNames = async () => {
      const speakerIds = [...new Set(reports.map(r => r.speakerId))];
      const names: {[key: string]: string} = {};

      for (const id of speakerIds) {
        if (!id) continue;
        try {
          const speakerRef = collection(db, 'speakers');
          const q = query(speakerRef, where('__name__', '==', id));
          const querySnapshot = await getDocs(q);
          
          if (!querySnapshot.empty) {
            names[id] = querySnapshot.docs[0].data().name;
          }
        } catch (error) {
          console.error('Error fetching speaker:', error);
        }
      }

      setSpeakerNames(names);
    };

    fetchSpeakerNames();
  }, [reports]);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="p-4 border-b border-gray-200 flex justify-between items-center">
        <h3 className="font-medium text-gray-900">Rapports récents</h3>
        <Link 
          to="/worship-reports" 
          className="text-sm text-[#00665C] hover:text-[#004d45] transition-colors duration-200"
        >
          Voir tout
        </Link>
      </div>
      <div className="divide-y divide-gray-200">
        {reports.map((report) => (
          <div key={report.id} className="p-4 hover:bg-gray-50 transition-colors duration-200">
            <div className="flex justify-between items-start">
              <div className="space-y-1">
                <div className="flex items-center space-x-2 text-sm text-gray-500">
                  <Calendar size={16} />
                  <span>{new Date(report.date).toLocaleDateString('fr-FR')}</span>
                </div>
                <p className="font-medium text-gray-900">{report.messageTheme}</p>
                <div className="flex items-center space-x-2 text-sm text-gray-600">
                  <Mic2 size={16} />
                  <span>{speakerNames[report.speakerId] || 'Orateur inconnu'}</span>
                </div>
              </div>
              <button
                onClick={() => onPreview(report)}
                className="text-[#00665C] hover:text-[#004d45] transition-colors p-1"
              >
                <Eye size={18} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}